import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import ModuloEnum from "@/core/utils/ModuloEnum"

const componentRouterView = {
    render(c) {
        return c("router-view")
    },
}
const createRegisterRoute = ({
    baseUrl,
    name,
    titleList,
    listComponent,
    menu,
    othersRoutes = [],
}) => ({
    path: baseUrl,
    component: componentRouterView,
    children: [
        {
            path: "/",
            name: `listar${name}`,
            meta: { description: titleList, menu },
            component: listComponent,
        },
        ...othersRoutes,
    ],
})

const routes = {
    path: "/almoxarifado",
    component: componentRouterView,
    meta: {
        modulo: ModuloEnum.ALMOXARIFADO,
        moduleName: "Almoxarifado",
        icon: "box-seam",
        sistema: 2,

    },
    children: [
        createRegisterRoute({
            baseUrl: "almoxarifado",
            name: "Almoxarifado",
            titleList: "Almoxarifado",
            listComponent: () => import("./almoxarifado/AlmoxarifadoList.vue"),
            menu: { name: "Almoxarifado", permissao: PrivilegiosEnum.ALMOXARIFADO_ACESSAR, },
            othersRoutes: [
            ],
        }),
        createRegisterRoute({
            baseUrl: "registroentrada",
            name: "RegistroEntrada",
            titleList: "Registro de Entrada",
            listComponent: () => import("./registros-entrada/RegistroEntradaList.vue"),
            menu: { name: "Registro de Entrada", permissao: PrivilegiosEnum.REG_ENTRADA_ACESSAR },
        }),

        createRegisterRoute({
            baseUrl: "pedidos",
            name: "Pedidos",
            titleList: "Pedidos",
            listComponent: () => import("./pedidos/PedidoList.vue"),
            menu: { name: "Pedidos", permissao: PrivilegiosEnum.PEDIDO_ACESSAR },

            othersRoutes: [
            ],
        }),


        createRegisterRoute({
            baseUrl: "itens-consumidos",
            name: "ItensConsumidos",
            titleList: "Itens consumidos",
            listComponent: () => import("./itens-consumidos/ItensConsumidosList.vue"),
            menu: { name: "Itens Consumidos", permissao: PrivilegiosEnum.ITENS_CONSUMIDOS_ACESSAR },
        }),

        createRegisterRoute({
            baseUrl: "consulta-produtos",
            name: "ConsultaProdutos",
            titleList: "Produtos do Almoxarifado",
            listComponent: () =>
                import("./consulta-produtos/ConsultaProdutosList.vue"),
            menu: { name: "Consulta Produtos", permissao: PrivilegiosEnum.PEDIDO_ACESSAR },
        }),

        createRegisterRoute({
            baseUrl: "empenho",
            name: "Empenho",
            titleList: "Empenho",
            listComponent: () => import("./empenho/EmpenhoList.vue"),
            menu: { name: "Empenho", permissao: PrivilegiosEnum.EMPENHO_ACESSAR },
        }),

        createRegisterRoute({
            baseUrl: "itens-almoxarifado",
            name: "ItensAlmoxarifado",
            titleList: "Itens do Almoxarifado",
            listComponent: () =>
                import("./itens-almoxarifado/ItensAlmoxarifadoList.vue"),
            menu: { name: "Itens do Almoxarifado", permissao: PrivilegiosEnum.ITEM_BEM_CONSUMO_ACESSAR },
        }),

        createRegisterRoute({
            baseUrl: "manuais-roteiros-atos",
            name: "ManuaisRoteirosAtos",
            titleList: "Manuais, Roteiros e Atos",
            listComponent: () =>
                import("./manuais-roteiros-atos/ManuaisRoteirosAtosList.vue"),
            menu: { name: "Manuais, Roteiros e Atos", permissao: PrivilegiosEnum.MANUAIS_ROTEIROS_ATOS_ACESSAR },
        }),

        createRegisterRoute({
            baseUrl: "devolucao",
            name: "Devolucao",
            titleList: "Devolução",
            listComponent: () => import("./devolucao/DevolucaoList.vue"),
            menu: { name: "Devolução", permissao: PrivilegiosEnum.DEVOLUCAO_ACESSAR },
            othersRoutes: [
            ],
        }),
        createRegisterRoute({
            baseUrl: "baixa-item-bem-consumo",
            name: "BaixaItemBemConsumo",
            titleList: "Baixa Item Bem Consumo",
            listComponent: () =>
                import(
                    "../almoxarifados/baixa-item-bem-consumo/BaixaItemBemConsumoList.vue"
                ),
            menu: { name: "Baixa Item Bem Consumo", permissao: PrivilegiosEnum.BAIXA_ITEM_BEM_CONSUMO_ACESSAR },
            othersRoutes: [
            ],
        }),
        createRegisterRoute({
            baseUrl: "inventario-item-bem-consumo",
            name: "InventarioItemBemConsumo",
            titleList: "Inventário Item Bem Consumo",
            listComponent: () =>
                import(
                    "../almoxarifados/inventario-item-bem-consumo/InventarioItemBemConsumoList.vue"
                ),
            menu: { name: "Inventário Item Bem Consumo", permissao: PrivilegiosEnum.INVENTARIOS_ACESSAR },
            othersRoutes: [
            ],
        }),
    ],
}

export default routes
